import { SharingInfo } from 'owa-sharing-data';
import { userDate } from 'owa-datetime/lib/userDate';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';

export default function createSharingInfoFromGetSharingInfoResponse(
    response: GetSharingInfoResponse
): SharingInfo | null {
    if (!response || response.ResultCode !== AttachmentResultCode.Success) {
        return null;
    }

    return {
        getSharingInfoSucceeded: true,
        canonicalUrl: response.CanonicalUrl,
        canShareInternally: response.CanShareInternally,
        canShareExternally: response.CanShareExternally,
        expirationDate: response.ExpirationDate ? userDate(response.ExpirationDate) : null,
        ignoreExpirationDate: false,
        canRefreshExpiration: true,
        shareId: null,
        recipientPermissionInfos: [],
        hasDLRecipient: false,
    };
}
